export const ASSIGN_LICENSE = 'assign_license';
export const CREATE_PLATFORM_ROLE = 'create_platform_role';
export const CREATE_PLATFORM_USER = 'create_platform_user';
export const DEACTIVATE_PLATFORM_USER = 'deactivate_platform_user';
export const DELETE_PLATFORM_ROLE = 'delete_platform_role';
export const PLATFORM_PASSWORD_RESET = 'platform_password_reset';
export const REACTIVATE_PLATFORM_USER = 'reactivate_platform_user';
export const UNASSIGN_LICENSE = 'unassign_license';
export const UPDATE_PLATFORM_ROLE = 'update_platform_role';
export const UPDATE_PLATFORM_USER = 'update_platform_user';
export const CREATE_PLATFORM_DEPARTMENT = 'create_platform_department';
export const UPDATE_PLATFORM_DEPARTMENT = 'update_platform_department';
export const UPDATE_COMPANY_PROFILE = 'update_company_profile';
export const ACCOUNT_INFO_AND_BILLING = 'update_company_profile';
